import { deriveMessageId } from "./derive-message-id"

/**
 * @typedef {object} VocabPluralMeta
 * @property {string} count - placeholder name for numeric count (e.g. interval)
 */

/**
 * @typedef {object} MessageDefinition
 * @property {string} template - English source template
 * @property {string} [id] - optional explicit id
 * @property {string} [namespace] - catalogue namespace (default core)
 * @property {Record<string, VocabPluralMeta>} [vocabPlural] - e.g. { period: { count: "interval" } }
 */

/** @type {Map<string, MessageDefinition>} */
const byId = new Map()

/**
 * @param {MessageDefinition} def
 */
export function registerMessageDefinition(def) {
    const id = deriveMessageId(def.template, def.id)
    byId.set(id, { namespace: "core", ...def, id })
}

/**
 * @param {string} template
 * @param {string} [explicitId]
 * @returns {MessageDefinition|undefined}
 */
export function getMessageDefinition(template, explicitId) {
    const id = deriveMessageId(template, explicitId)
    return byId.get(id)
}

registerMessageDefinition({ template: "Every" })

// Initial catalogue (mirrors server message-catalogue for client fallback metadata)
registerMessageDefinition({
    template: "Every {interval} {period}.",
    vocabPlural: { period: { count: "interval" } },
})

registerMessageDefinition({ template: "Skill Required" })
registerMessageDefinition({ template: "Frequency" })
registerMessageDefinition({ template: "Estimated Task Duration" })
registerMessageDefinition({ template: "Duration not specified" })
registerMessageDefinition({ template: "The unit of measurement for this task" })
registerMessageDefinition({
    template:
        "0U (Zero U) tasks which means the frequency that those tasks should be carried out is to be defined by the user based on a site-specific assessment.",
})
registerMessageDefinition({ template: "{minutes} minutes {seconds} seconds" })
registerMessageDefinition({ template: "{totalMinutes} minutes" })
registerMessageDefinition({ template: "Minutes : Seconds" })
registerMessageDefinition({ template: "Please refer to the " })
registerMessageDefinition({ template: "overarching introduction" })
registerMessageDefinition({
    template:
        " (SFG 00-01) to make sure you are of the correct skill level as indicated within the task schedule to carry out the described works. Ensure you have read and understood the manufacturer's recommendations, carried out risk assessment(s) on each item of plant to identify the correct frequency of maintenance, identified all safety procedures that need to be applied and recorded in order to carry out the work in a safe and reliable manner.",
})
registerMessageDefinition({
    template:
        "If this asset (item of equipment/system) is within the warranty or guarantee period, it is essential that you maintain it in full accordance with the specific manufacturer's or installer's maintenance requirements. If you are in any doubt about the maintenance requirements or the warranty or guarantee period please contact the manufacturer, installer or their representative to seek clarity.",
})
registerMessageDefinition({ template: "Check List" })
registerMessageDefinition({ template: "Smart Words:" })
registerMessageDefinition({
    template:
        "This check list is a short summary of the task, it is not the SFG20 task. This summary may be used to remind individuals performing the task about the steps, but they must be familiar with the full schedule. They can access the full schedule by using the SFG20 app and the Smart Words associated with the task.",
})
